import { axiosInstance } from "../../Utils/AxiosInstance";

export const GetAllUOMApi = async () => {
  try {
    const response = await axiosInstance.get(`/Store/Uom/GetAll`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const AddUOMApi = async (data) => {
  try {
    const response = await axiosInstance.post(`/Store/Uom/Create`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const DeleteUOMApi = async (id) => {
  try {
    const response = await axiosInstance.delete(`/Store/Uom/Delete/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const EditUOMApi = async (id, data) => {
  try {
    const response = await axiosInstance.put(`/Store/Uom/Edit/${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
